<template>
  <el-drawer title="详情" :visible.sync="drawer" :modal-append-to-body="false" append-to-body destroy-on-close custom-class="widthSpecial" :wrapperClosable="false">
    <el-form status-icon size="small" label-width="73px" label-position="left" class="mx-20-4 pl-10 bg-#fff pr-30 py-20" style="padding-bottom: 20px">
      <div class="form-Title mx-20-2">申请信息</div>
      <el-form-item label="存放仓库:">
        {{ previewForm.warehouseName || '-' }}
      </el-form-item>
      <el-form-item label="物资分类:">
        {{ previewForm.materialCategoryName || '-' }}
      </el-form-item>
      <el-form-item label="申请人:">
        {{ previewForm.staffName || '-' }}
      </el-form-item>
      <el-form-item label="采购用途：">
        {{ previewForm.reason || '-' }}
      </el-form-item>

      <div class="form-Title mx-20-2">物资详情</div>
      <el-table :data="previewForm.materialPurchaseItems" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column prop="name" label="物资名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.name || '-' }}
          </template>
        </el-table-column>

        <el-table-column prop="number" label="数量" align="center">
          <template slot-scope="scope">{{ scope.row.number || '-' }} {{ dictType('materialUnit', scope.row.unit) }}</template>
        </el-table-column>
      </el-table>

      <div class="form-Title mx-20-2" style="margin-top: 20px">审批流程</div>
      <el-table :data="previewForm.flowAuditLogs" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column label="序号" type="index" width="50" align="center" />
        <el-table-column prop="flowConfigStepName" label="操作阶段" align="center">
          <template slot-scope="scope">
            {{ scope.row.operatePhase || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="auditStaffName" label="操作人" align="center">
          <template slot-scope="scope">
            {{ scope.row.auditStaffName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="operateType" label="操作类型" align="center">
          <template slot-scope="scope">
            {{ dictType('operateTypeArr', scope.row.operateType) }}
          </template>
        </el-table-column>
        <el-table-column prop="operateType" show-overflow-tooltip label="备注" align="center">
          <template slot-scope="scope">
            {{ scope.row.remark || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="操作时间" align="center">
          <template slot-scope="scope">
            {{ cutTime(scope.row.createTime, ' ') }}
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-form
      v-if="isExamine"
      ref="examinForm"
      label-width="83px"
      status-icon
      :model="examinForm"
      size="small"
      :rules="rules"
      label-position="left"
      class="mx-20-1 pt-24 bg-#fff pr-30"
    >
      <div class="form-Title mx-20-2">审批信息</div>
      <el-form-item label="审批结果：" prop="operateType">
        <el-radio v-model="examinForm.operateType" :label="3">通过</el-radio>
        <el-radio v-model="examinForm.operateType" :label="2">驳回</el-radio>
      </el-form-item>
      <el-form-item v-if="examinForm.operateType === 2" label="驳回原因：" prop="remark">
        <el-input v-angle="examinForm.remark" v-model="examinForm.remark" maxlength="30" show-word-limit placeholder="填写驳回原因" clearable />
      </el-form-item>
    </el-form>
    <FixedTwoButton v-if="isExamine" activeClass="widthSpecial">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import formatData from '@/utils/formatRequestData'
import { flowApplyAudit } from '@/api/workManage'
import { flowApplyPurchaseInfo } from '@/api/materialManage'
export default {
  inject: ['indexThis'],
  props: {
    applyOverviewId: {
      type: String,
      default: '',
    },
    isExamine: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      previewForm: {},
      examinForm: { operateType: 3, remark: '' },
      rules: {
        operateType: [{ required: true, message: '审批结果不能为空', trigger: 'change' }],
        remark: [{ required: true, message: '驳回原因不能为空', trigger: 'blur' }],
      },
    }
  },
  watch: {
    'examinForm.operateType': {
      deep: true,
      handler(val) {
        if (val === 3) return
        this.examinForm.remark = ''
      },
    },
  },
  methods: {
    async getDetail(id) {
      const { data: res } = await flowApplyPurchaseInfo({ id: id || this.applyOverviewId })
      this.previewForm = res
    },

    async submitForm() {
      const valid = await this.$refs.examinForm.validate().catch(() => {})
      if (!valid) return false
      const { data: res } = await flowApplyAudit({
        ...formatData(this.examinForm),
        auditStaffId: this.$store.getters.staffId,
        auditStaffName: this.$store.getters.name,
        flowApplyOverviewId: this.applyOverviewId,
      })
      if (!res) return this.$message.error('审批失败')
      this.$message.success('审批成功')
      this.indexThis.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.examinForm.resetFields()
    },
  },
}
</script>
